import type { ReadonlyURL } from "$app/state";
import { returnPathAllowed } from "@colossus/contracts";
import { rememberSession } from "../shell/me.ts";

const LOGIN_PATH = "/api/auth/login";

const RETURN_PARAM = "return";

const SIGN_IN_STARTED_KEY = "colossus.sign-in-started";

const SIGN_IN_REPEAT_MS = 3_000;

export const returnPathOf = (url: ReadonlyURL): string | null => {
  const value = url.searchParams.get(RETURN_PARAM);
  return value !== null && returnPathAllowed(value) ? value : null;
};

export const loginHref = (here: ReadonlyURL, drawnAhead = false): string => {
  const origin = `${LOGIN_PATH}?${RETURN_PARAM}=${encodeURIComponent(here.origin)}`;
  if (drawnAhead) return origin;
  const carried = returnPathOf(here);
  const path =
    carried !== null ? carried : here.pathname === "/" ? null : `${here.pathname}${here.search}`;
  return path === null ? origin : `${origin}&path=${encodeURIComponent(path)}`;
};

export const signInHref = (url: URL): string =>
  `/?${RETURN_PARAM}=${encodeURIComponent(`${url.pathname}${url.search}`)}`;

const signInUnderway = (now: number): boolean => {
  const started = Number(sessionStorage.getItem(SIGN_IN_STARTED_KEY));
  return now >= started && now - started < SIGN_IN_REPEAT_MS;
};

export const rememberSignIn = (event: MouseEvent): void => {
  const href =
    event.target instanceof Element ? event.target.closest("a")?.getAttribute("href") : null;
  if (href === null || href === undefined) return;
  if (new URL(href, globalThis.location.href).pathname !== LOGIN_PATH) return;
  const now = Date.now();
  if (signInUnderway(now)) {
    event.preventDefault();
    return;
  }
  sessionStorage.setItem(SIGN_IN_STARTED_KEY, String(now));
  rememberSession(true);
};
